<template>
  <v-container class="booking-detail p-0" v-if="subscription && facilityType" fluid>
    <vue-headful :title="$t('header.facility') + $t('title')"></vue-headful>
    <HkiaraceBannerFrame :src="'api/static/'+facilityType.banner"
                         :label="$t('my_account.gym_subscriptions')">
      <v-container class="booking-detail-content" fluid>
        <v-row>
          <v-col order="2" cols="12"
                 order-md="1" md="6">
            <v-row>
              <v-col>
                <v-text-field :label="$t('gym_subscription.reference_number')"
                              readonly
                              :value="subscription.reference_number.toString().padStart(10, '0')"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field readonly
                              :label="$t('gym_subscription.status')"
                              :value="subscriptionStatus"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field readonly
                              :label="$t('gym_subscription.type')"
                              :value="subscription.type.name"></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col order="1" cols="12"
                 order-md="2" md="6"
                 class="text-md-right">
            <!--<qrcode :value="subscription.reference_number.toString()" :options="{ width: '10rem' }" class="account-info-membership-big-qrcode"></qrcode>-->
            <qrcode :value="subscription.reference_number.toString().padStart(10, '0')" :options="{ width: '10rem' }" class="account-info-membership-big-qrcode"></qrcode>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
          <v-col>
            <GymSubscriptionCheckInRecordList :subscription-id="subscription.id"></GymSubscriptionCheckInRecordList>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-left">
            <v-btn color="primary"
                   @click="$router.back()">
              {{ $t('back') }}
            </v-btn>
          </v-col>
        </v-row>

      </v-container>
    </HkiaraceBannerFrame>
  </v-container>
</template>

<script>
import {library} from '@fortawesome/fontawesome-svg-core'
import {faChevronCircleLeft} from '@fortawesome/free-solid-svg-icons'
import HkiaraceBannerFrame from "../../../components/HkiaraceBannerFrame";
import {computed, onMounted, ref} from "@vue/composition-api";
import GymSubscriptionCheckInRecordList from "@/components/acc_booking/GymSubscriptionCheckInRecordList";
import {BOOKING_STATUS_LABEL} from "@/constants";

library.add(faChevronCircleLeft);

export default {
  name: 'GymPassDetail',
  components: {GymSubscriptionCheckInRecordList, HkiaraceBannerFrame},
  setup(props, {root}) {
    const facilityType = ref(null);
    const getFacilityType = function () {
      root.$callAPI('aafb/gym_subscription/get_facility_type/', {}, function (response) {
        facilityType.value = response.body.facility_type;
      });
    };

    const subscription = ref(null);
    const subscriptionStatus = computed(() => {
      return subscription.value ? root.$t(BOOKING_STATUS_LABEL[subscription.value.status]) : '';
    })
    const getSubscription = function () {
      root.$callAPI('aafb/gym_subscription/', {subscription_id: root.$route.params.subscriptionId}, function (response) {
        subscription.value = response.body.subscription;
      })
    };

    onMounted(() => {
      getFacilityType();
      getSubscription();
    });

    return {
      facilityType,
      subscription,
      subscriptionStatus,
    }
  },
}
</script>

<style lang="less">
.booking-detail {
  padding: 30px;

  .booking-detail-content {
    background-color: white;
    padding: 2rem;

    .v-label {
      color: #8E765B;
    }

    .v-text-field > .v-input__control > .v-input__slot:before {
      display: none;
    }

    .v-text-field > .v-input__control > .v-input__slot:after {
      display: none;
    }
  }

  .fa-chevron-circle-left {
    font-size: 5em;
    cursor: pointer;
  }

  .confirm-message-label {
    text-align: left;
    line-height: 2.5em;
    font-size: 2em;
  }

  .booking-summary-title {
    text-align: left;
    font-size: 2.5em;
  }

  .booking-preview-form {
    border: 1px solid rgba(0, 0, 0, 0.5);
    border-radius: 10px;
    padding: 30px;
    font-size: 1.2em;

    .col-form-label {
      color: rgba(0, 0, 0, 0.5);
      text-align: left;
    }
  }

  .accept-tnc {
    text-align: left;
    padding: 30px;
    font-size: 1.2em;
  }
}

.countdown {
  text-align: right;
}
</style>
